import {Component} from '@angular/core';
import {ButtonComponent} from '../../../shared/components/button/eretail-button/button.component';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';

@Component({
  standalone: true,
  templateUrl: './expired-token-dialog.component.html',
  imports: [MatButtonModule, MatDialogModule, MatIconModule, ButtonComponent],
})
export class ExpiredTokenDialog {}
